import Checkbox, { type Props as CheckboxProps } from '@components/Checkbox';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';

interface Props extends CheckboxProps {
    onClick?: () => void;
    required?: boolean;
}

function CheckboxLI(props: Props) {
    const {
        isChecked, toggleCheckbox, children, onClick, required,
    } = props;
    return (
        <Container aria-label='check-box-list-item'
            onClick={onClick}>
            <CheckboxWrapper>
                <Checkbox isChecked={isChecked}
                    toggleCheckbox={toggleCheckbox}>
                    {children}
                    {required && <Required>*</Required>}
                </Checkbox>
            </CheckboxWrapper>
            <ArrowLineRight color={colors.gray5}/>
        </Container>
    );
}

const Container = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    width: 100%;

    [aria-label='checkbox'] {
        width: auto;
    }
`;

const Required = styled.span`
    color: var(--color-primary);
    font-size: 16px;
    line-height: 20px;
    margin-left: 8px;
`;

const CheckboxWrapper = styled.div`
    flex: 1;
`;

export default CheckboxLI;
